import { getUserSessionData } from '@/Application/Hooks/GetCustomerData';
import type { IOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  Divider,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';
import { formatRut, isDeviceKiosco } from '@/modules/perseo-billing/utils';
import { RECEIPT_DNI_DOCUMENT_NUMBER } from '@/modules/shared/types/IdentificationDocumentType';

import type { TInfoBlock } from '.';
import ChangeEmailInfo from './change-email-info.component';
import FeedBackInfo from './feedback-info.component';
import InfoBlock from './info-block.component';

interface IContactInfo {
  customer: IOrderConfirmation['customer'];
  authType: IOrderConfirmation['authType'];
  isForeignDocument?: boolean;
}

export const ContactInfo = ({
  customer,
  authType,
  isForeignDocument = false
}: IContactInfo) => {
  const isMobile = useMediaQuery('lg');
  const isKiosco = isDeviceKiosco();
  const {
    isBill = false,
    firstName,
    email,
    rut,
    phone,
    lastName
  } = customer || {};
  const isUserAuthenticated = authType === 'registered';

  const sessionData = getUserSessionData();
  const customerEmail = email || sessionData?.email || '';

  const infoBlocks: TInfoBlock[] = [
    {
      icon: 'CustomerIcon',
      title: 'Persona que compra:',
      value: firstName + ' ' + lastName
    },
    {
      icon: 'MailIcon',
      title: 'Correo electrónico:',
      value: customerEmail
    },
    {
      icon: 'PhoneIcon',
      title: 'Teléfono:',
      value: phone
    },
    {
      icon: 'ReceiptIcon',
      title: isForeignDocument ? 'Documento:' : isBill ? 'Boleta:' : 'Factura:',
      value: isForeignDocument
        ? RECEIPT_DNI_DOCUMENT_NUMBER
        : formatRut(rut ?? '')
    }
  ];

  return (
    <div className="co-w-full co-flex co-flex-col co-rounded-8px co-gap-16px co-py-24px co-px-16px co-border-1 co-border-[#E6E6E6] co-bg-white lg:co-py-24px lg:co-px-32px">
      <Typography
        size="h2"
        weight="semibold"
        className="co-text-pds-neutral-900"
        tabIndex={0}
      >
        {'Datos de contacto'}
      </Typography>
      <Divider />
      <div className="co-flex co-flex-col co-gap-8px lg:co-flex-row">
        {infoBlocks.map((block, i) => (
          <InfoBlock key={i} {...block} />
        ))}

        {!isUserAuthenticated && (
          <ChangeEmailInfo className="lg:co-hidden co-flex" />
        )}

        {isMobile && (
          <FeedBackInfo isBill={isBill} isForeignDocument={isForeignDocument} />
        )}
      </div>
      {!isUserAuthenticated && (
        <ChangeEmailInfo className="co-hidden lg:co-flex" />
      )}
      {!isMobile && !isKiosco && (
        <FeedBackInfo isBill={isBill} isForeignDocument={isForeignDocument} />
      )}
    </div>
  );
};
